export const sliderItems = [
    {
      id: 1,
      img: "https://scontent.fdad2-1.fna.fbcdn.net/v/t1.6435-9/78058906_2625587644176287_8983323106340765696_n.jpg?_nc_cat=101&ccb=1-5&_nc_sid=0debeb&_nc_ohc=PAf3xoezFzoAX8XHntd&_nc_ht=scontent.fdad2-1.fna&oh=49f11b6a20fb17d70bd94e7dc64db78d&oe=619B50CA",
      title: "ĐỒ ĂN VẶT TẠI NHÀ",
      desc: "ĐẶT HÀNG LIỀN ĐỂ THƯỞNG THỨC TẠI NHÀ CHẤT LƯỢNG QUÁ OK",
      bg: "f5fafd",
    },
    {
      id: 2,
      img: "https://scontent.fdad1-2.fna.fbcdn.net/v/t1.6435-9/90455151_2845155412219508_714919150622867456_n.jpg?_nc_cat=106&ccb=1-5&_nc_sid=0debeb&_nc_ohc=eCg9-N3eB8AAX8ngr1j&_nc_ht=scontent.fdad1-2.fna&oh=21f2800e652d9a79e679e70cf113f076&oe=619A3779",
      title: "ĐỒ ĂN NGON BỔ RẺ",
      desc: "MIỄN PHÍ GIAO HÀNG TRONG KHU VỰC , ẤN TƯỢNG NGAY LẦN ĐẦU",
      bg: "fcf1ed",
    },
    {
      id: 3,
      img: "https://scontent.fdad2-1.fna.fbcdn.net/v/t1.6435-9/91005604_2862530527148663_4650141639472316416_n.jpg?_nc_cat=107&ccb=1-5&_nc_sid=0debeb&_nc_ohc=VkMtfG3HYE8AX8JfsDL&_nc_ht=scontent.fdad2-1.fna&oh=e04a660f326d2cbe5a87d495cef33beb&oe=619C6585",
      title: "MÓN NGON CHẤT LƯỢNG",
      desc: "ĐỦ MỌI MÓN NGON KHIẾN BẠN ƯA THÍCH TRONG MỘT NỐT NHẠC",
      bg: "fbf0f4",
    },
  ];

  export const categories = [
    {
      id: 1,
      img: "https://scontent.fdad1-1.fna.fbcdn.net/v/t1.6435-9/76169700_2584117281656657_4323831224280809472_n.jpg?_nc_cat=103&ccb=1-5&_nc_sid=0debeb&_nc_ohc=D11ILMZ-BcYAX9_CyZb&_nc_ht=scontent.fdad1-1.fna&oh=e498e17e03e036ef2525e536a91b8013&oe=6198A047",
      title: "ĐỒ ĂN VẶT!",
      cat:"min"
    },
    {
      id: 2,
      img: "https://scontent.fdad1-3.fna.fbcdn.net/v/t1.6435-9/78449937_2628873860514332_5963308099015016448_n.jpg?_nc_cat=110&ccb=1-5&_nc_sid=0debeb&_nc_ohc=eyse3GbxdR8AX8Fmhno&_nc_ht=scontent.fdad1-3.fna&oh=e31d68535fa378eaf407e1dbf0b10b54&oe=61993E9A",
      title: "MÓN NGON",
      cat:"men"
    },
    {
      id: 3,
      img: "https://scontent.fdad1-1.fna.fbcdn.net/v/t1.6435-9/81926995_2686938808041170_9015034271521308672_n.jpg?_nc_cat=109&ccb=1-5&_nc_sid=0debeb&_nc_ohc=ezAJnApEAu4AX91hdAp&_nc_ht=scontent.fdad1-1.fna&oh=a8bd55bd63e657e831147863da5b0f91&oe=619BA050",
      title: "GIÒ CHẢ",
      cat:"mon"
    },
  ];

  export const popularProducts = [
    {
      id:1,
      img:"https://scontent.fdad1-3.fna.fbcdn.net/v/t1.6435-9/78282721_2625587690842949_1093846802135777280_n.jpg?_nc_cat=104&ccb=1-5&_nc_sid=0debeb&_nc_ohc=NKgmmDwt1XsAX_YGyPl&_nc_ht=scontent.fdad1-3.fna&oh=7b3d15649fc8d0d90d50db5db4dca98f&oe=619A1018",
    },
    {
      id:2,
      img:"https://scontent.fdad2-1.fna.fbcdn.net/v/t1.6435-9/78058906_2625587644176287_8983323106340765696_n.jpg?_nc_cat=101&ccb=1-5&_nc_sid=0debeb&_nc_ohc=PAf3xoezFzoAX8XHntd&_nc_ht=scontent.fdad2-1.fna&oh=49f11b6a20fb17d70bd94e7dc64db78d&oe=619B50CA",
    },
    {
      id:3,
      img:"https://scontent.fdad1-2.fna.fbcdn.net/v/t1.6435-9/78338358_2631639183571133_4536914554814201856_n.jpg?_nc_cat=105&ccb=1-5&_nc_sid=0debeb&_nc_ohc=PwM_zpJgxIcAX9S4htD&_nc_ht=scontent.fdad1-2.fna&oh=1b970114a072bb730eca53359374d766&oe=619B2A3A",
    },
    {
      id:4,
      img:"https://scontent.fdad1-2.fna.fbcdn.net/v/t1.6435-9/79618365_2629356067132778_6945696552744648704_n.jpg?_nc_cat=102&ccb=1-5&_nc_sid=0debeb&_nc_ohc=14_793ZG158AX9V2NzB&_nc_ht=scontent.fdad1-2.fna&oh=6eb6a317a762d2611792dd1a8088e6b2&oe=619AC534",
    },
    {
      id:5,
      img:"https://scontent.fdad2-1.fna.fbcdn.net/v/t1.6435-9/78923617_2629356057132779_2046216818900598784_n.jpg?_nc_cat=101&ccb=1-5&_nc_sid=0debeb&_nc_ohc=FjoLCqKUws8AX-CUBdo&_nc_ht=scontent.fdad2-1.fna&oh=66d995b6444365ad4c45d4457706cef8&oe=619A19F9",
    },
    {
      id:6,
      img:"https://scontent.fdad2-1.fna.fbcdn.net/v/t1.6435-9/79440123_2646062285462156_5215506554219921408_n.jpg?_nc_cat=108&ccb=1-5&_nc_sid=0debeb&_nc_ohc=6CH-4tl7fX4AX-ggGMe&_nc_ht=scontent.fdad2-1.fna&oh=b55b87775bc1a3e302652dffb56f2dd2&oe=619C5878",
    },
    {
      id:7,
      img:"https://scontent.fdad1-2.fna.fbcdn.net/v/t1.6435-9/78852957_2642212419180476_7363633287673151488_n.jpg?_nc_cat=102&ccb=1-5&_nc_sid=0debeb&_nc_ohc=DAma00hFk54AX8xV5E8&_nc_ht=scontent.fdad1-2.fna&oh=84a1f94bf82025ec24622d4d96bab77f&oe=619BC923",
    },
    {
      id:8,
      img:"https://scontent.fdad1-1.fna.fbcdn.net/v/t1.6435-9/78774839_2635621666506218_5046816267650990080_n.jpg?_nc_cat=103&ccb=1-5&_nc_sid=0debeb&_nc_ohc=HeCWM_Ev5TkAX95BWQH&_nc_ht=scontent.fdad1-1.fna&oh=444bd422dbbe46084625a9d480012eb6&oe=619B0341",
    },
  ]